<template>
     <div class="procedure">
      <div class="procedureBox">
        <!-- 填写信息 -->
       <div class="procedureImOrText">
          <img src="@/assets/channel/firstbusiness/TXsuccess.png" alt="填写信息" class="OpenAccountProcessImg">
          填写信息
        </div>
        <div class="procedureImOrText" v-if="false">
          <img src="@/assets/channel/OpenAccountProcess/openAnAccount.png" alt="填写信息" class="OpenAccountProcessImg">
          填写信息
        </div>
        <!-- 虚线 -->
        <div  :class="[ Status.UploadFileStatus ==2 ?  'line' : 'lines']">
        </div>
        <!-- 审核中 -->
        <div class="procedureImOrText" v-if="Status.ExamineStatus == 0" style="color: #ced3d9;">
          <img src="@/assets/channel/firstbusiness/info.png" alt="审核中" class="OpenAccountProcessImg">
          审核中
        </div>
        <div class="procedureImOrText" v-if="Status.ExamineStatus == 2">
          <img src="@/assets/channel/firstbusiness/success.png" alt="审核中" class="OpenAccountProcessImg">
          审核中
        </div>
        <div class="procedureImOrText" v-if="Status.ExamineStatus == 1">
          <img src="@/assets/channel/OpenAccountProcess/openAnAccount.png" alt="审核中" class="OpenAccountProcessImg">
          审核中
        </div>
        <!-- 虚线 -->
        <div class="line" :class="[ Status.SucceeStatus == 2 ?  'line' : Status.SucceeStatus == -1 ? 'lineError' : 'lines']">
        </div>
        <!-- 审核成功 -->
        <div class="procedureImOrText" v-if="Status.SucceeStatus == 0" style="color: #ced3d9;">
          <img src="@/assets/channel/OpenAccountProcess/openAnAccount-H.png" alt="审核成功" class="OpenAccountProcessImg">
          审核成功
        </div>
        <div class="procedureImOrText" v-if="Status.SucceeStatus == 2">
          <img src="@/assets/channel/OpenAccountProcess/openAnAccount.png" alt="审核成功" class="OpenAccountProcessImg">
          审核成功
        </div>
         <div class="procedureImOrText" v-if="Status.SucceeStatus == -1">
          <img src="@/assets/channel/firstbusiness/error.png" alt="已驳回" class="OpenAccountProcessImg">
          <span style="color: #E71D43;">已驳回</span>
        </div>
      </div>
    </div>
</template>

<script>
  export default {
    components:{},
    props:{
      Status: {
        type: Object
      }
    },
    data(){
      return {
          
      }
    },
    created(){},
    mounted(){},
    activated(){},
    updated(){},
    methods:{},
    computed:{},
    watch:{},
  }
</script>
<style scoped lang='less'>

  .procedure {
    height: 80px;
    width: 100%;
    border-bottom: 1px solid #eaecef;

    .procedureBox {
      width: 80%;
      height: 33px;
      margin-left: 80px;
      //   background-color: red;
      margin-top: 23px;
      display: inline-block;

      .procedureImOrText {
        font-weight: normal;
        font-size: 16px;
        color: #00266d;
        display: inline-block;
      }
    }
  }
  .OpenAccountProcessImg {
    width: 35.75px;
    height: 35.75px;
    vertical-align: middle;
    margin-right: 5px;
  }
  .line {
  display: inline-block;
  width: 100px;
  height: 1px;
  border-bottom: 1px dashed #00266d;
  margin-left: 50px;
  margin-right: 50px;
  margin-bottom: 5px;
}
.lines {
    display: inline-block;
  width: 100px;
  height: 1px;
  border-bottom: 1px dashed #ced3d9;
  margin-left: 50px;
  margin-right: 50px;
  margin-bottom: 5px;
}
.lineError {
    display: inline-block;
  width: 100px;
  height: 1px;
  border-bottom: 1px dashed #E71D43;
  margin-left: 50px;
  margin-right: 50px;
  margin-bottom: 5px;
}
</style>